// @flow
export const API_URL = window ? `${window.location.origin}/api` : 'https://freight-calculator.klappir.io/api'; // 'http://localhost:9000/api'; //
export const VEHICLE_EMISSION_FACTOR = 0.204;
